export const PURCHASE_ORDER_BASE_PATH = '/inventory/purchase-orders';

const encodeReturnParam = (value) => encodeURIComponent(value || '');

export const buildProcurementCreatePath = (path, params = {}, returnTo, returnLabel) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  if (returnTo) search.set('returnTo', returnTo);
  if (returnLabel) search.set('returnLabel', returnLabel);
  const query = search.toString();
  return query ? `${path}?${query}` : path;
};

export const getReturnTarget = (location, searchParams, fallbackPath, fallbackLabel) => {
  const stateFrom = location?.state?.from;
  const stateLabel = location?.state?.returnLabel;
  const queryFrom = searchParams?.get('returnTo');
  const queryLabel = searchParams?.get('returnLabel');
  return {
    path: stateFrom || queryFrom || fallbackPath,
    label: stateLabel || queryLabel || fallbackLabel,
  };
};

export const buildReturnState = (from, returnLabel) => ({
  from,
  returnLabel,
});

export const buildEncodedReturnTo = (path) => encodeReturnParam(path);
